// extracted by mini-css-extract-plugin
module.exports = {"popoverContainer":"styles_popoverContainer__3rJb_","popoverArrowElement":"styles_popoverArrowElement__lmfxj","popoverArrowContainer":"styles_popoverArrowContainer__ChiMH"};